import React, { useState, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Select from "react-select";
import "../Styles/LoginPage.css";
import logo from "../assests/images/LoginLogo.png";
import { saveData } from "../utils/store-data";
import {
  AGENT_LOGIN,
  CLIENT_LOGIN,
  CLIENT_PROFILE_CODE,
  GOOGLE_USER,
  IS_TEMP_REGISTERED,
  LOGIN_BY,
  PHNO,
  PROFILE_LOGIN,
  USER_EMAIL,
  USER_ID,
} from "../utils/store-data-constants";
import {
  enable_user_account,
  get_all_countries,
  log_in,
  log_in_by_google,
  register_user_by_email,
} from "../api/serverWrapper";
import { useGoogleLogin } from "@react-oauth/google";
import UserSystemRole from "../components/UserSystemRole";
import EmailLogin from "./EmailLogin";
import EmailSignup from "./EmailSignup";
import VerifyEmailOtp from "./VerifyEmailOtp";
import { loginByEmail, loginByGoogle } from "../utils/Constants";
import { isValidPhoneNumber } from "libphonenumber-js";
import { useMasterData } from "../context/MasterDataContext";
import { GOOGLE_LOGIN_API } from "../api/app_url";
import AccountStatusModals from "../hooks/AccountStatusModals";
import { useAccountStatusGate } from "../hooks/useAccountStatusGate";
import { routeUserAfterLogin } from "../utils/loginNavigation";
import { getPhoneCountryOptions } from "../utils/commonFunctions";
const Login = () => {
  const location = useLocation();
  const loginType = location.state?.loginType || "Agent";
  const [emailMode, setEmailMode] = useState(null);
  const [signupEmail, setSignupEmail] = useState("");
  const [signupPassWord, setSignupPassWord] = useState("");
  // null | "login" | "signup"
  const [loading, setLoading] = useState(false);
  const [loadingforMobile, setLoadingforMobile] = useState(false);

  const {
    accountDeletedPopup,
    setAccountDeletedPopup,
    accountDisabledPopup,
    setAccountDisabledPopup,
    isEnabling,
    checkAccountStatus,
    handleReactivateAccount,
  } = useAccountStatusGate();

  const [phone, setPhone] = useState("");

  const [showSelect, setShowSelect] = useState(false);
  const {
    allCountyMasterData,
    selectedCountryCode,
    setSelectedCountryCode,
    selectedCountryIsoCode,
    setSelectedCountryIsoCode,
  } = useMasterData();

  const navigate = useNavigate();

  const countries = useMemo(
    () => getPhoneCountryOptions(allCountyMasterData),
    [allCountyMasterData],
  );

  const selectedCountryOption =
    countries.find((country) => country.isoCode === selectedCountryIsoCode) ||
    countries.find((country) => country.value === String(selectedCountryCode)) ||
    null;

  const handleClick = () => {
    // navigate("/login");
    navigate("/signup");
  };

  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      setLoading(true);
      try {
        const res = await fetch(GOOGLE_LOGIN_API, {
          headers: {
            Authorization: `Bearer ${tokenResponse.access_token}`,
          },
        });

        console.log(res);

        if (!res.ok) {
          throw new Error("Failed to fetch Google user info");
        }

        const data = await res.json();

        console.log("Google user:", data);

        /*
        data contains:
        - email
        - name
        - picture
        - sub (google user id)
      */

        // 👉 Send this to your backend
        // await api.googleLogin(data);

        // navigate("/otp_verify", { state: { loginType } });
        await login(data.email, data);
      } catch (err) {
        console.error("Google login error", err);
        alert("Google Login Failed");
      } finally {
        setLoading(false);
      }
    },
    onError: () => {
      alert("Google Login Failed");
    },
  });

  const login = async (EMail, UserInfo) => {
    try {
      const resp = await log_in_by_google({ EMail });
      if (resp?.data) {
        const user = resp.data;
        if (checkAccountStatus(user)) return;
        await routeUserAfterLogin(user, navigate, {
          email: EMail,
          replace: true,
        });
      } else {
        await saveData(LOGIN_BY, loginByGoogle);
        await saveData(USER_EMAIL, EMail);
        await saveData(GOOGLE_USER, JSON.stringify(UserInfo));
        navigate("/terms-and-conditions");
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Handle login

  const handleLogin = async () => {
    // if (!/^\d{10}$/.test(phone)) {
    //   alert("Enter a valid mobile  number");
    //   return;
    // }

    const fullPhoneNumber = `+${selectedCountryCode}${phone}`;

    if (!isValidPhoneNumber(fullPhoneNumber, selectedCountryIsoCode)) {
      alert("Enter a valid mobile number");
      return;
    }

    setLoadingforMobile(true);

    try {
      const data = {
        PhoneNumber: phone,
        CountyCode: selectedCountryCode,
      };

      const resp = await log_in(data);
      console.log(resp);

      if (resp.data) {
        // Registered user
        await saveData(PHNO, phone);
        navigate("/otp_verify", { state: { loginType } });
      } else {
        // Unregistered user
        alert(
          "This phone number is not registered. Please sign up to continue.",
        );
      }
    } catch (error) {
      console.error(error);
      alert("This phone number is not registered. Please sign up to continue.");
    } finally {
      setLoadingforMobile(false);
    }
  };

  const selectStyles = {
    option: (provided) => ({
      ...provided,
      textAlign: "left",
      paddingLeft: "12px",
    }),
    singleValue: (provided) => ({
      ...provided,
      textAlign: "left",
    }),
    menu: (provided) => ({
      ...provided,
      textAlign: "left",
    }),
  };

  const navigateToRegisterScreen = async () => {
    try {
      let data = {
        EMail: signupEmail,
        Password: signupPassWord,
        SystemRole:
          loginType === "Agent"
            ? UserSystemRole.AGENT.id
            : UserSystemRole.CLIENT.id,
        IsTempRegistered: 1,
        LoginBy: loginByEmail,
      };

      let res = await register_user_by_email(data);
      if (res.success) {
        await saveData(LOGIN_BY, loginByEmail);
        await saveData(USER_EMAIL, signupEmail);
        await saveData(USER_ID, res.data.UserId);
        await saveData(IS_TEMP_REGISTERED, true);
        if (loginType === "Agent") {
          navigate("/business_setup");
        } else {
          navigate("/client_setup");
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="left-panel">
        <div className="curve-image"></div>
        <img src={logo} alt="WedLuk Logo" className="logo" />
        <p className="tagline-for-login">
          Matrimony reimagined for the AI generation.
        </p>
      </div>

      <div className="right-panel">
        {emailMode === null && (
          <div className="login-card">
            <h2> Login</h2>

            {/* Phone Input with Country Code Selector */}
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleLogin();
              }}
            >
              <div className="phone-input">
                <span
                  className="country-code"
                  onClick={() => setShowSelect((prev) => !prev)}
                  style={{ cursor: "pointer" }}
                >
                  +{selectedCountryCode}
                </span>

                <input
                  type="tel"
                  placeholder="Contact Number"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))}
                  maxLength={15}
                />
              </div>
              {showSelect && (
                <div className="country-select-popup">
                  <Select
                    classNamePrefix="react-select"
                    options={countries}
                    styles={{
                      ...selectStyles,
                      menuPortal: (provided) => ({
                        ...provided,
                        zIndex: 10000,
                      }),
                    }}
                    value={selectedCountryOption}
                    getOptionValue={(option) => option.isoCode}
                    onChange={(opt) => {
                      if (opt) {
                        setSelectedCountryCode(opt.value);
                        setSelectedCountryIsoCode(opt.isoCode);
                        setShowSelect(false);
                      }
                    }}
                    autoFocus
                    isSearchable
                    menuPlacement="auto"
                    menuPosition="fixed"
                    menuPortalTarget={document.body}
                    maxMenuHeight={240}
                  />
                </div>
              )}


              <button
                type="submit"
                className="login-btn-login"
                disabled={loadingforMobile}
              >
                {loadingforMobile ? (
                  <span className="spinner"></span>
                ) : (
                  <>
                    Login <span className="login-arr">{">"}</span>
                  </>
                )}
              </button>
            </form>

            <div className="divider-or-use">or use</div>

            <button
              className="login-google"
              onClick={googleLogin}
              disabled={loading}
            >
              {loading ? (
                <span className="spinner"></span>
              ) : (
                <>
                  <i className="fab fa-google"></i> Login using Google →
                </>
              )}
            </button>

            {/* <button
            className="login-email"
            
            disabled={loadingforFacebook}
          >
            {loadingforFacebook ? (
              <span className="spinner"></span>
            ) : (
              <>
                <i className="fab fa-facebook-f"></i> Login using Facebook →
              </>
            )}
          </button> */}

            <button
              className="login-email"
              onClick={() => setEmailMode("login")}
            >
              <i className="fa-solid fa-envelope-circle-check"></i> {"  "}
              Login using Email →
            </button>
          </div>
        )}

        {emailMode === "login" && (
          <EmailLogin setEmailMode={setEmailMode} loginType={loginType} />
        )}

        {emailMode === "signup" && (
          <EmailSignup
            setEmailMode={setEmailMode}
            setSignupEmail={setSignupEmail}
            setSignupPassWord={setSignupPassWord}
          />
        )}

        {emailMode === "otp" && (
          <VerifyEmailOtp
            email={signupEmail}
            onVerified={() => navigateToRegisterScreen()}
          />
        )}

        {!emailMode && (
          <div className="signup-box">
            <p
              onClick={handleClick}
              disabled={loading}
              style={{ cursor: "pointer" }}
            >
              Not registered with us?{" "}
              <span style={{ color: "#BF3175" }}> Signup {">"} </span>
            </p>
            <p className="subtext">
              Use WedLuk to find better matches for your clients—and expand your
              reach by joining our nationwide agent network.
            </p>
          </div>
        )}

        {accountDeletedPopup && (
          <div className="modal-overlay">
            <div className="confirm-modal">
              <h2>Account Deleted</h2>
              <p>
                Your account has been permanently deleted. Please contact
                support if you believe this is a mistake.
              </p>
              <div className="modal-actions">
                <button
                  className="confirm-btn"
                  onClick={() => {
                    setAccountDeletedPopup(false);
                    navigate("/home");
                  }}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        )}

        {accountDisabledPopup && (
          <div className="modal-overlay">
            <div className="confirm-modal">
              <h2>Account Disabled</h2>
              <p>
                Your account is currently disabled. Would you like to reactivate
                your account?
              </p>
              <div className="modal-actions">
                <button
                  className="confirm-btn"
                  onClick={handleReactivateAccount}
                  disabled={isEnabling}
                  style={{
                    opacity: isEnabling ? 0.7 : 1,
                    cursor: isEnabling ? "not-allowed" : "pointer",
                  }}
                >
                  {isEnabling ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                      }}
                    >
                      <span className="spinner"></span>
                      Enabling...
                    </div>
                  ) : (
                    "Enable Account"
                  )}
                </button>
                <button
                  className="cancel-btn"
                  onClick={() => {
                    setAccountDisabledPopup(false);
                    navigate("/home");
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

        <AccountStatusModals
          accountDeletedPopup={accountDeletedPopup}
          setAccountDeletedPopup={setAccountDeletedPopup}
          accountDisabledPopup={accountDisabledPopup}
          setAccountDisabledPopup={setAccountDisabledPopup}
          isEnabling={isEnabling}
          handleReactivateAccount={handleReactivateAccount}
        />
      </div>
    </div>
  );
};

export default Login;
